// extracted by mini-css-extract-plugin
export default {"viewport":"FlaskWidget_viewport__Anywa","loading":"FlaskWidget_loading__BoFPL"};